import React from 'react'
import { Link } from 'react-router-dom'
import { LogoutOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import MenuUnfoldOutlined from "@ant-design/icons/MenuUnfoldOutlined";
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { ENV } from '../config';



const Header = ({ collapsed, setCollapsed, setResMenuToggle, resMenuToggle }) => {

    const user = useSelector(state => state.user.userInfo);

    const { keycloak } = useKeycloak();

    const navigate = useNavigate()


    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    // close resposive menu state
    const toggleResponsiveMenu = () => {
        setResMenuToggle(!resMenuToggle);
    };

    const handleLogout = () => {
        keycloak.logout({
            redirectUri: `${ENV.REACT_APP_OCELOTLINK}/`,
        });
    };



    const menu = (
        <Menu className="menu-ul">

            <Menu.Item key="3" className="menu-title">
                <LogoutOutlined style={{ marginRight: "10px" }} /> <span onClick={() => handleLogout()}>Log Out</span>
            </Menu.Item>
        </Menu>
    );


    return (
        <div className="bg-primary sm:rounded-2xl sm:p-5 p-4 text-white relative">
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <button type="button" onClick={toggleResponsiveMenu} className='text-3xl 2xl:text-2xl xl:hidden w-10 h-10 flex items-center justify-center'>
                        <MenuUnfoldOutlined />
                    </button>
                    <Link to={"/"} className='inline-block  xl:ml-20'>
                        <img src="/images/Ocelot-Link-White-Logo.png" className='xl:h-16 sm:h-12 h-9 w-auto' alt="" />
                    </Link>
                    <button type="button" onClick={toggleCollapsed} className='text-xl 2xl:text-2xl absolute bottom-5 left-5 hidden xl:inline-block'>
                        {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
                    </button>
                </div>

                <Dropdown
                    className='inline-block xl:-mt-3'
                    overlay={menu}
                    trigger={['click']}
                >
                    <a onClick={(e) => e.preventDefault()}>
                        <span className='!bg-white !text-primary font-semibold pb-1 !w-10 !h-10 inline-flex justify-center items-center rounded-full text-base md:text-xl'>
                            {`${user?.profile?.first_name.charAt(0)}${user?.profile?.last_name.charAt(0)}`.toUpperCase()}
                        </span>
                    </a>
                </Dropdown>
            </div>
        </div>
    )
}

export default Header